import type { BurndownBeaconId, BurndownSettings } from '../types/burndown';

export const BURNDOWN_BEACON_ID: BurndownBeaconId = 'burndown';

export const BURNDOWN_SETTINGS_DEFAULTS: BurndownSettings = {
	hidden: false,
};
